import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { formatDate } from "@backpacker/date";
import { localize } from "@backpacker/number";
import { shorten } from "@backpacker/number";
import { Dot } from "@charty/legend/item";
import { Spacing } from "@glossy";
import { AbstractDate, Interval } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import { percent } from "@tootools/number";
import Tooltip from ".";

type Serie = {
  count: number;
  label: string;
  color: string;
  date: AbstractDate;
  total?: number;
};
interface IProps {
  locale: Locale;
  series: Serie[];
  metricLabel?: string;
  isNormalized?: boolean;
  timeUnit?: Interval;
}

const Line = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${Spacing.ExtraSmall};
`;

function getDateFormat(date: AbstractDate, locale: Locale, timeUnit: Interval) {
  if (timeUnit === "month") {
    return formatDate(date, locale, "MMMM YYYY").replace(/^\w/, (c) =>
      c.toUpperCase()
    );
  }
  return formatDate(date, locale, "ll");
}

const TooltipSimpleSerie = ({
  locale,
  series,
  metricLabel,
  isNormalized,
  timeUnit,
}: IProps) => (
  <Tooltip
    label={getDateFormat(series[0].date, locale, timeUnit)}
    content={
      <>
        {isNormalized && metricLabel
          ? metricLabel
          : metricLabel && (
              <div>
                {series[0].total && series[0].total} {metricLabel}
              </div>
            )}
        {map(series, (serie, index) => (
          <Line key={index}>
            <Dot color={serie.color} />
            <span>
              {serie.label}:{" "}
              {isNormalized &&
                shorten(
                  locale,
                  percent(serie.count, serie.total),
                  3,
                  false,
                  1
                ) + "% - "}{" "}
              {localize(locale, serie.count)}
            </span>
          </Line>
        ))}
      </>
    }
  />
);

export default TooltipSimpleSerie;
